import { createStore } from 'zustand';
import { Address } from '@/types/gearApi/Address';

export type AccountDataState = {
	firstName: string | undefined;
	lastName: string | undefined;
	billingProfiles: Address[];
	selectedBillingProfile: Address | undefined;
};

type AccountDataActions = {
	setSelectedBillingProfile: (selectedBillingProfile: Address) => void;
};

export type AccountDataStore = AccountDataState & AccountDataActions;

export const createAccountDataStore = (initState: AccountDataState) => {
	return createStore<AccountDataStore>()((set) => ({
		...initState,
		setSelectedBillingProfile: (selectedBillingProfile: Address) => set({ selectedBillingProfile }),
	}));
};
